module.exports = __webpack_public_path__ + "img/s8Bg6.acae1ea2.jpg";